import { Box, Grid } from "@mui/material";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import { useTranslate } from "src/locales";
import ByzTitleAndInputBox from "src/components/core-components/ByzTitleAndInputBox/ByzTitleAndInputBox";
import { ByzMuiDatePicker } from "src/components/core-components/mui/inputs/ByzMuiDatePicker";
import ByzMuiSelect from "src/components/core-components/mui/ByzMuiSelect";
import ByzTitleBox from "./title-box";
function FormFiller() {
  const { t } = useTranslate();
  return (
    <Box>
      <ByzTitleBox title={t("safe-birth-control-form.form-filler")} />

      <Grid
        item
        xs={12}
        container
        spacing={3}
        sx={{ display: "flex", flexWrap: "wrap" }}
      >
        <Grid item sm={6} xs={12} md={4} xl={3}>
          <Grid
            item
            sx={{
              display: "flex",
              flexDirection: "column",

              padding: "8px 0",
              justifyContent: {
                md: "left",
                xl: "left",
                xs: "center",
              },
            }}
          >
            <ByzTitleAndInputBox title={t("datetime")}>
              <ByzMuiDatePicker label="" sx={{ ml: "8px" }} />
            </ByzTitleAndInputBox>
          </Grid>
        </Grid>

        <Grid item sm={6} xs={12} md={4} xl={3}>
          <Grid
            item
            sx={{
              display: "flex",
              flexDirection: "column",

              padding: "8px 0",
              justifyContent: {
                md: "left",
                xl: "left",
                xs: "center",
              },
            }}
          >
            <ByzTitleAndInputBox
              title={t("safe-birth-control-form.registered")}
            >
              <ByzMuiSelect
                sx={{ ml: "8px" }}
                renderInput={(params: any) => (
                  <ByzMuiTextField {...params} label="" variant="outlined" />
                )}
                options={[]}
                color="primary"
                label={t("partograf-form.chose")}
                placeholder={t("partograf-form.chose")}
              />
            </ByzTitleAndInputBox>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}

export default FormFiller;
